import {
  VIEW_WEEKLY, VIEW_MONTHLY, VIEW_YEARLY
} from './constants';

export default function periodRangeReducer(range = 'weekly', action){

  switch(action.type){

     case VIEW_WEEKLY:
      return 'weekly';

     case VIEW_MONTHLY:
      return 'monthly';
     
     case VIEW_YEARLY:
      return 'yearly';

  }

  return range;
}
